import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const SideMenu = ({ sections }) => {
  const [openSections, setOpenSections] = useState({});

  // Toggle the open state of each section
  const toggleSection = (index) => {
    setOpenSections(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <div className="w-64 h-full bg-gray-900 text-white p-4 overflow-auto">
      <h2 className="text-2xl font-bold mb-6">Learn JavaScript</h2>
      {sections.map((section, index) => (
        <div key={index} className="mb-4">
          {/* Section Title (accordion trigger) */}
          <button
            onClick={() => toggleSection(index)}
            className="flex justify-between w-full px-4 py-2 font-medium text-left bg-gray-800 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-lg transition-colors"
          >
            <span>{section.sectionTitle}</span>
            <span>{openSections[index] ? '-' : '+'}</span>
          </button>
          
          {/* Accordion Content (Articles) */}
          {openSections[index] && (
            <ul className="mt-2 pl-4 space-y-2">
              {section.articles.map(article => (
                <li key={article.id}>
                  <Link
                    to={`/article/${article.id}`}
                    className="block px-4 py-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded-md transition-colors"
                  >
                    {article.title}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};

export default SideMenu;
